// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"125":"049e60bd","161":"08e1c0f5","299":"2cff143a","386":"5e54addf","439":"262d3fc6","456":"7097604b","481":"b4683e12","702":"318a376f","829":"0d7bbb1a","871":"33d3da3b","876":"2c96c5bb"}[chunkId] + ".js";
};